import { Grid } from '@material-ui/core';
import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import T from 'components/common/text/T';
import AppItemCard from 'components/store/AppItemCard';
import { IProduct } from 'lib/types/storeTypes';
import { StoreActions } from 'store/actionCreators';
import { useShallowAppSelector } from 'store/hooks';
import AppModal from 'components/common/modal/AppModal';
import PlainModal from 'components/common/modal/PlainModal';
import { useDidUpdateEffect } from 'lib/utils';
import { useTranslation } from 'react-i18next';
import AppStoreModal from './AppStoreModal';
import { isClinicUserSelector } from 'store/modules/user';

interface AppItemListProps {}

function AppStoreContainer({}: AppItemListProps) {
  const {
    user: { currencyCode },
    fetchStoreProducts: { productList: productListData },
    fetchStoreProductSuccess,
    language,
    isClinicUser,
  }: {
    user: { currencyCode: string };
    fetchStoreProducts: { productList: IProduct[] };
    fetchStoreProductSuccess: boolean;
    language: string;
    isClinicUser: boolean;
  } = useShallowAppSelector(state => ({
    user: state.user.user || {},
    fetchStoreProducts: state.store.storeProducts.data || { productList: {} },
    fetchStoreProductSuccess: state.store.storeProducts.success,
    language: state.base.language,
    isClinicUser: isClinicUserSelector(state),
  }));

  const { ipcRenderer } = window;

  const [appModalOpen, setAppModalOpen] = useState(false);
  const [productList, setProductList] = useState<IProduct[] | null>(null);
  const [releaseNote, setReleaseNote] = useState<string | null>(null);
  const { t } = useTranslation();

  const handleCloseAppModal = () => {
    setAppModalOpen(false);
  };
  const handleClickAppModal = (productCode: string) => {
    setReleaseNote(productCode);
    setAppModalOpen(true);
  };

  const handleOpenBrowser = (url: string) => {
    ipcRenderer.send('openBrowser', {
      url,
    });
  };

  useEffect(() => {
    // init
    // StoreActions.fetch_store_product_list_request({ type: 1, currency: 'KRW' });
    StoreActions.fetch_store_product_list_request({
      type: 1,
      currency: currencyCode,
      language: language,
    });
  }, []);

  useDidUpdateEffect(() => {
    if (fetchStoreProductSuccess && !!productListData) {
      setProductList(productListData);
    }
  }, [productListData, fetchStoreProductSuccess]);

  return (
    <StyledAppStoreContainer data-component-name="AppStoreContainer">
      <h1 className="sr-only">
        <T>Apps</T>
      </h1>
      <div className="appStore__info_wrapper">
        <p>
          <T>STORE_APPS_TEXT_1</T>
        </p>
        <p>
          <T>STORE_APPS_TEXT_2</T>
        </p>
      </div>
      <div className="appStore__app_list_wrapper">
        <Grid container className="appStore__app_list_container">
          {!!productList &&
            productList?.map((product: IProduct, index: number) => {
              let whoCanUse = 'STORE_COMMON';
              let usable = true;
              if (product.productCode === 'APP_SCAN_MODEL_SCANNER') {
                whoCanUse = 'STORE_LAB_ONLY';
                usable = !isClinicUser;
              }
              if (product.productCode === 'APP_DENTWEB') {
                whoCanUse = 'STORE_CLINIC_ONLY';
                usable = !!isClinicUser;
              }

              if (product.productCode === 'APP_MOTIONAPP') {
                return (
                  <AppItemCard
                    product={product}
                    onClickAppModal={handleClickAppModal}
                    key={index}
                    usable={usable}
                    whoCanUse={whoCanUse}
                    onOpenBrowser={handleOpenBrowser}
                  />
                );
              } else {
                return (
                  <AppItemCard
                    product={product}
                    onClickAppModal={handleClickAppModal}
                    key={index}
                    usable={usable}
                    whoCanUse={whoCanUse}
                  />
                );
              }
            })}
        </Grid>
      </div>
      {useMemo(
        () => (
          <PlainModal isOpen={appModalOpen} onClose={handleCloseAppModal} width={570}>
            <AppModal
              title={t('RELEASE_NOTE_TITLE')}
              // headerCenterText={''}
              // headerCenterTextStyle={{ width: 325 }}
              content={<AppStoreModal releaseNote={releaseNote} />}
              contentCardStyle={{
                padding: '10px 10px 30px 10px',
                borderRadius: '8px',
              }}
              isCloseIcon={true}
              onClick={handleCloseAppModal}
              onCancel={handleCloseAppModal}
              // hideButton={true}
            />
          </PlainModal>
        ),
        [appModalOpen],
      )}
    </StyledAppStoreContainer>
  );
}

const StyledAppStoreContainer = styled.section<{}>`
  padding: 45px 45px;
  .appStore__info_wrapper {
    display: flex;
    flex-direction: column;
    row-gap: 30px;
    margin-bottom: 30px;
    p {
      font-size: 16px;
      font-weight: 400;
      line-height: normal;
    }
    p:first-child {
      font-size: 24px;
      font-weight: 600;
      line-height: normal;
    }
    p:not(:first-child) {
    }
  }

  .appStore__app_list_wrapper {
    /* width: 1580px;
    margin: 0 auto; */
    .appStore__app_list_container {
      column-gap: 30px;
      row-gap: 30px;
    }
  }
`;

export default React.memo(AppStoreContainer);
